<script setup>
  const authStore = useAuthStore()
  const { userQuality } = useAuthData()
  const user = computed(() => authStore.user)
  const { setLoginModalRef } = useAuthModal()
  const localePath = useLocalePath()
  const router = useRouter()

  const loginRef = ref(null)

  const handleLogout = async () => {
    authStore.logout()
    await router.push(localePath({ name: 'index' }))
  }

  onMounted(() => {
    if (loginRef.value) {
      setLoginModalRef(loginRef.value)
    }
  })

  // Watch for authentication changes and re-register the modal ref
  watch(
    () => authStore.user,
    async (newUser, oldUser) => {
      // User logged out - wait for next tick to ensure component is re-rendered
      if (!newUser && oldUser) {
        await nextTick()
        if (loginRef.value) {
          setLoginModalRef(loginRef.value)
        }
      }
    },
    { flush: 'post' }
  )

  // Also watch for the loginRef to change and re-register
  watch(
    loginRef,
    (newRef) => {
      if (newRef) {
        setLoginModalRef(newRef)
      }
    },
    { flush: 'post' }
  )
</script>
<template>
  <ClientOnly>
    <div v-if="user">
      <AuthAccount :key="`account-${userQuality}-${user.id}`" :user="user">
        <template #menu>
          <button
            type="button"
            class="w-full cursor-pointer flex items-center gap-2 px-3 py-2 text-sm text-red-700 hover:bg-red-50 hover:text-red-700 rounded-md transition-colors duration-200 font-medium"
            @click="handleLogout()"
          >
            <font-awesome class="fa-fw" :icon="['fas', 'sign-out-alt']" />
            {{ $t('pages.auth.menu.disconnect') }}
          </button>
        </template>
      </AuthAccount>
    </div>
    <div v-else>
      <AuthLogin ref="loginRef" />
    </div>
    <template #fallback>
      <!-- <Skeleton width="2.5rem" height="2.5rem" border-radius="50%"></Skeleton> -->
      <div class="flex items-center gap-2 px-2">
        <div class="w-[22px] h-[22px] bg-white/20 rounded-full items-center justify-center flex">
          <font-awesome class="text-xs" :icon="['fas', 'user']" />
        </div>
      </div>
    </template>
  </ClientOnly>
</template>
